import { useEffect, useState } from 'react';

import Quiz from 'my-components/Quiz';
import QuizCtnr from 'my-components/QuizCtnr';

import GatedDialog from './GatedDialog';

import LinearProgress from '@mui/material/LinearProgress';

export default function CourseAssessment(props) {
  const {
    assignmentId,
    attemptContext,
    canView,
    courseId,
    courseSlug,
    courseSubscription,
    eventTrackingProperties,
    fetching,
    hideQuestionForm,
    instructionMode,
    isFinalExam,
    onCompleted,
    onlineCourse,
    onlineCourseId,
    // onStartTrial,
    onlineCourseUser,
    onPurchase,
    onSaveProgress,
    onTokenPurchase,
    onViewingChange,
    quiz,
    quizQuestionSkipDisabled,
    quizSettingOverrides,
    resultsPagePromoVariant,
    reviewMode,
    scoreGate,
    skipCover,
    slotProps,
    slots,
    studyPlannerItemId,
    subscription,
    // subscriptionTrialStatus,
    title,
    tokenPurchaseStatus,
    uiMode,
    userCourse,
  } = props;

  const [gatedDialogOpen, setGatedDialogOpen] = useState(false);
  useEffect(() => {
    Quiz.preload();
  }, []);

  if (fetching && !quiz) {
    return <LinearProgress />;
  }
  const quizProps = {
    fetching,
    finalExam: isFinalExam,
    hideQuestionForm,
    eventTrackingProperties,
    courseSlug,
    instructionMode,
    onlineCourseQuestionProps: (onlineCourse || onlineCourseId) && {
      activity: quiz,
      eventTrackingProperties,
      onlineCourse,
      onlineCourseId,
      courseId,
      assignmentId,
      onPurchase,
      subscription,
    },
    onViewingChange,
    quizQuestionSkipDisabled,
    reviewMode,
    scoreGate,
    skipCover,
    title,
    uiMode,
    quizSettingOverrides,
    slotProps,
    slots,
  };

  if (!canView) {
    const Gate = slots?.gate || GatedDialog;

    return (
      <>
        <Quiz
          {...quizProps}
          onBegin={() => setGatedDialogOpen(true)}
          onRestartQuiz={() => {}}
          onSaveSubmissions={() => {}}
          quiz={quiz}
        />
        <Gate
          activityText={isFinalExam ? 'Mock Exam' : 'Quiz'}
          courseSubscription={courseSubscription}
          eventTrackingProperties={eventTrackingProperties}
          onClose={() => setGatedDialogOpen(false)}
          onlineCourse={onlineCourse}
          onlineCourseUser={onlineCourseUser}
          onPurchase={onPurchase}
          onTokenPurchase={onTokenPurchase}
          open={gatedDialogOpen}
          // onStartTrial={onStartTrial}
          subscription={subscription}
          // subscriptionTrialStatus={subscriptionTrialStatus}
          tokenPrice={Math.max(1, parseInt((quiz?.questions_count || 0) / 2))}
          tokenPurchaseStatus={tokenPurchaseStatus}
          userCourse={userCourse}
        />
      </>
    );
  }
  return (
    <QuizCtnr
      attemptContext={attemptContext}
      courseAssignmentId={assignmentId}
      studyPlannerItemId={studyPlannerItemId}
      eventTrackingProperties={eventTrackingProperties}
      onlineCourseId={onlineCourse?.id || onlineCourseId}
      quizId={quiz.id}
    >
      {({ fetching, onSubmitQuiz, ...rest }) =>
        !fetching && (
          <Quiz
            {...quizProps}
            onSaveActivityProgress={onSaveProgress}
            onSubmitQuiz={
              !onCompleted ? onSubmitQuiz : (
                (...args) => Promise.resolve(onSubmitQuiz(...args)).then(err => !err && onCompleted())
              )
            }
            resultsPagePromoVariant={resultsPagePromoVariant}
            {...rest}
          />
        )
      }
    </QuizCtnr>
  );
}
